import React from 'react'
import {
  TruCheck,
  TruCheckCircle,
  TruCross,
  TruTick,
  TruThumbUp,
  TruThumbDown,
  TruBullet,
} from '@uswitch/spark-icons/tru'

const ICONS = {
  'check-circle': { icon: <TruCheckCircle /> },
  checklist: { icon: <TruCheck /> },
  cons: { icon: <TruThumbDown /> },
  cross: { icon: <TruCross />, color: 'error' },
  pros: { icon: <TruThumbUp /> },
  'thumb-down': { icon: <TruThumbDown />, color: 'error' },
  'thumb-up': { icon: <TruThumbUp />, color: 'success' },
  tick: { icon: <TruTick />, color: 'success' },
  bullet: { icon: <TruBullet />, color: 'grey-100' },
}

export default ICONS
